var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileCopyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3251_11981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.5H2C1.45 0.5 1 0.95 1 1.5V8C1 8.275 1.225 8.5 1.5 8.5C1.775 8.5 2 8.275 2 8V2C2 1.725 2.225 1.5 2.5 1.5H7.5C7.775 1.5 8 1.275 8 1C8 0.725 7.775 0.5 7.5 0.5ZM7.795 2.795L10.21 5.21C10.395 5.395 10.5 5.65 10.5 5.915V10.5C10.5 11.05 10.05 11.5 9.5 11.5H3.995C3.445 11.5 3 11.05 3 10.5L3.005 3.5C3.005 2.95 3.45 2.5 4 2.5H7.085C7.35 2.5 7.605 2.605 7.795 2.795ZM7.5 6H9.75L7 3.25V5.5C7 5.775 7.225 6 7.5 6Z",
    fill: "#2C2A4C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3251_11981"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCopyIcon);
export default __webpack_public_path__ + "static/media/file-copy-icon.4ba78f0f74af07f5f8e56b492c44ad0f.svg";
export { ForwardRef as ReactComponent };